import { render, staticRenderFns } from "./ButtonsStepWizardForm.vue?vue&type=template&id=3c29c455"
import script from "./ButtonsStepWizardForm.vue?vue&type=script&lang=js"
export * from "./ButtonsStepWizardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports